import { Card, Typography, Button, Container, Stack, TableContainer, TableHead, TableRow, TableCell, Table, TableBody, Popover, MenuItem, IconButton, Avatar, Dialog, DialogTitle, DialogContent, Grid, TextField, Autocomplete, FormControl, Select, Switch, Chip, Box, InputBase } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import '../../Common_css/style.css';
import Iconify from 'src/components/iconify';
import { deleteData, formPostData, getData, patchFormData, postData } from "src/webService/webService";
import { toast, ToastContainer } from "react-toastify";
import uploadIcon from '../../components/images/profile-picture.png';
import deleteIcon from '../../components/icons/remove.png';
import Loader from "../Loader/Loader";
import { countries } from "country-data";
import ViewBrand from "../viewProduct/viewBrand";

export default function Merchant() {

    const [open, setOpen] = useState(null);
    const [merchant, setMerchant] = useState([]);
    const Token = sessionStorage.getItem('Token');
    const [openModal, setOpenModal] = useState(false);
    const [name, setName] = useState('');
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [whatsappNo, setWhatsappNo] = useState('');
    const [aboutUs, setAboutUs] = useState('');
    const [address, setAddress] = useState('');
    const [mapLocation, setMapLocation] = useState(null);
    const [instaLink, setInstaLink] = useState(null);
    const [facebookLink, setFaceBookLink] = useState(null);
    const [twitterLink, setTwitterLink] = useState(null);
    const [websiteLink, setWebsiteLink] = useState(null);
    const [category, setCategory] = useState('');
    const [categories, setCategories] = useState([]);
    const [categoriesArray, setCategoriesArray] = useState([]);
    const [profileImage, setProfileImage] = useState(null);
    const [action, setAction] = useState('');
    const [id, setId] = useState('');
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [country, setCountry] = useState('');
    const [viewProduct, setViewProduct] = useState(false);
    const [sellerResponse, setSellerResponse] = useState();
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [TotalItems, setTotalItems] = useState(null);
    const [phoneCountryCode, setPhoneCountryCode] = useState('');
    const [whatsappCountryCode, setWhatsappCountryCode] = useState('');
    const [loading, setLoading] = useState(false);
    const [activeStates, setActiveStates] = useState({});
    const [subCategoriesArray, setSubCategoriesArray] = useState([]);
    const [subCategory, setSubCategory] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [brandsCount, setBrandsCount] = useState(null);
    const [errors, setErrors] = useState({});

    const debounce = (func, delay) => {
        let timer;
        return function (...args) {
            clearTimeout(timer);
            timer = setTimeout(() => func.apply(this, args), delay);
        };
    };

    const debouncedSearch = debounce((query) => {
        if (query.length >= 3 || query.length === 0) {
            setSearchQuery(query);
            getMerchantData(1, query);
        }
    }, 500);

    const handleLimitChange = (event) => {
        setCurrentPage(1);
        setLimit(event.target.value);
    };
    const handleApproveAnotherBrand = async () => {
        debugger
        const payload = {
            available_brands: brandsCount
        }
        try {
            postData(`sellers/${id}/add-brand`, payload, Token)
                .then((res) => {
                    // toast.success('Seller updated successfully');
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
            handleCloseMenu();
            setOpenDialog(false)
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            await getMerchantData()
        }
    };

    const dialCodes = countries.all.map(c => ({
        dialCode: c.countryCallingCodes[0],
    }));

    const validDialCodes = dialCodes
        .filter(item => item.dialCode && item.dialCode.trim() !== '')
        .map(item => item.dialCode);

    console.log(validDialCodes, 'ocddnandfnadfianifds');



    const handlePrevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    console.log(categories, 'categorureaihefahoihfioahefih');



    const handleOpenModal = () => {
        setOpenModal(true);
        handleChange(category);
    }

    const handleClose = () => {
        setOpenModal(false);
    }

    const handleDeleteClose = () => {
        setOpenDeleteModal(false);
        handleCloseMenu();
    }

    const handleOpenDeleteModal = () => {
        setOpenDeleteModal(true);
    }

    const getMerchantData = async (page, search = "") => {
        setLoading(true);
        const params = {
            page: page,
            per_page: limit,
            search: search
        }
        try {
            const res = await getData('sellers', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setMerchant(res.data);
                setTotalItems(res?.total);
                setTotalPages(res?.last_page);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getMerchantData(currentPage, searchText);
    }, [limit, currentPage])

    const getCategoryData = async () => {
        const params = {
            // page: 1,
            // per_page: 20,
            all: 1,
            withChildren: 1
        }
        try {
            const res = await getData('categories', params, Token);
            if (res.status === 200) {
                console.log(res.data, "res.data");
                setCategoriesArray(res.data);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    useEffect(() => {
        getCategoryData();
    }, [])

    const getSellerById = async (id) => {
        debugger
        try {
            const res = await getData(`sellers/${id}`, null, Token);
            console.log(res, "res.name");
            setName(res?.name);
            setUserName(res?.username);
            setEmail(res?.email);
            setPhone(res?.phone);
            setWhatsappNo(res?.whatsapp);
            setAboutUs(res?.aboutus);
            setAddress(res?.address);
            setMapLocation(res?.map_location);
            setTwitterLink(res?.twitter_link);
            setFaceBookLink(res?.facebook_link);
            setInstaLink(res?.instagram_link);
            setWebsiteLink(res?.website_link);
            setPreview(res?.profile_picture == undefined || res?.profile_picture === null ? initialImage : res?.profile_picture);
            // setCategory(res?.category)
            // if (res?.category?.parent) {
            //     setCategory(res?.category?.parent);
            //     setSubCategory(res?.category);
            //     handleChange(res?.category?.parent, 'parentCategory');
            // } else {
            //     setCategory(res?.category);
            //     setSubCategory('');
            //     handleChange(res?.category, 'parentCategory');
            // }
            setCategories(res?.category || []);
            setId(res?._id);
            setCity(res?.city);
            setState(res?.state);
            setCountry(res?.country);
            setWhatsappCountryCode(res?.whatsapp_countrycode);
            setPhoneCountryCode(res?.phone_countrycode)
            setSellerResponse(res);
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }

    const handleChange = (event) => {
        const selectedId = event?._id;

        if (!selectedId) return;

        if (categories.includes(selectedId)) {
            setCategories(categories.filter(id => id !== selectedId));
        } else {
            setCategories([...categories, selectedId]);
        }
    };


    // const handleChange = async (event, status) => {
    //     debugger
    //     if (status === 'parentCategory') {
    //         const selectedEvent = event;
    //         const filteredEvent = categoriesArray?.find((item) => item?._id === selectedEvent?._id);
    //         setCategory(filteredEvent);

    //         if (filteredEvent?.subCategoryCount !== 0) {
    //             const params = {
    //                 all: 1,
    //                 category: filteredEvent?._id
    //             }
    //             try {
    //                 const res = await getData(`categories`, params, Token);
    //                 if (res.status === 200) {
    //                     console.log(res.data, "res.data");
    //                     setSubCategoriesArray(res.data);
    //                 }
    //             } catch (error) {
    //                 console.error("Error:", error);
    //                 toast.error("An error occurred. Please try again later.", {});
    //             }
    //         } else {
    //             setSubCategoriesArray([]);
    //             setSubCategory('');
    //         }
    //     }
    // }

    console.log(subCategory, 'subCategoryyyyy');


    const handleSubCategoryChange = (event, status) => {
        debugger
        if (status === 'parentCategory') {
            const selectedEvent = event;
            const filteredEvent = subCategoriesArray?.find((item) => item === selectedEvent);
            setSubCategory(filteredEvent);
        }
    }

    const handleCloseMenu = () => {
        setOpen(null);
        setName('');
        setUserName('');
        setEmail('');
        setPhone('');
        setWhatsappNo('');
        setAboutUs('');
        setAddress('');
        setMapLocation('');
        setTwitterLink('');
        setFaceBookLink('');
        setInstaLink('');
        setWebsiteLink('');
        setPreview(initialImage);
        setCategory('');
        setSubCategory('');
        setState('');
        setCity('');
        setCountry('');
        setPhoneCountryCode('');
        setWhatsappCountryCode('');
    };

    const handleOpenMenu = (event, id) => {
        setOpen(event.currentTarget);
        setBrandsCount(id);
    };

    const initialImage = uploadIcon;
    const [preview, setPreview] = useState(initialImage);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            setProfileImage(file)
        }
    };

    const handleSubmit = () => {
        debugger;
        if (action === 'Change Password' || action === 'Add') {
            if (password.length < 8) {
                toast.error('password must be in 8 characters');
                return;
            }
        }
        const formData = new FormData();
        if (action === 'Add' || action === 'Edit') {
            if (profileImage) {
                formData.append("profile_picture", profileImage);
            }

            if (name) formData.append('name', name);
            if (userName) formData.append('username', userName);
            if (email) formData.append('email', email);
            if (phone) formData.append('phone', phone);

            if (action === 'Add' && password) {
                formData.append('password', password);
            }

            if (aboutUs) formData.append('aboutus', aboutUs);
            if (whatsappNo) formData.append('whatsapp', whatsappNo);
            if (address) formData.append('address', address);
            if (mapLocation) formData.append('map_location', mapLocation);
            if (instaLink) formData.append('instagram_link', instaLink);
            if (facebookLink) formData.append('facebook_link', facebookLink);
            if (twitterLink) formData.append('twitter_link', twitterLink);
            if (websiteLink) formData.append('website_link', websiteLink);
            // if (category?._id) formData.append('category', subCategory._id === '' ? category?._id : subCategory?._id);
            // if (subCategoriesArray.length === 0) {
            //     if (category?._id) formData.append('category', category._id);
            // } else {
            //     if (category?._id && subCategory?._id) formData.append('category', subCategory._id);
            // }
            if (subCategoriesArray?.length === 0) {
                if (categories.length > 0) {
                    console.log(categories, 'categories')
                    // formData.append('category', categories);
                    formData.append('category', JSON.stringify(categories));
                    // formData.append('category', category._id);
                } else {
                    toast.error('Category is required');
                    return;
                }
            } else {
                if (category?._id && subCategory?._id) {
                    formData.append('category', subCategory._id);
                } else {
                    toast.error('Both Category and Subcategory are required');
                    return;
                }
            }
            if (city) formData.append('city', city);
            if (state) formData.append('state', state);
            if (country) formData.append('country', country);
            if (phoneCountryCode) formData.append('phone_countrycode', phoneCountryCode);
            if (whatsappCountryCode) formData.append('whatsapp_countrycode', whatsappCountryCode);



        } else if (action === 'Invite' && email) {
            formData.append('email', email);
        } else if (action === 'Change Password' && password) {
            formData.append('password', password);
        }



        if (action === 'Edit' || action === 'Change Password') {
            patchFormData(`sellers/${id}`, formData, Token)
                .then((res) => {
                    getMerchantData(currentPage);
                    getCategoryData();
                    handleClose();
                    handleCloseMenu();
                    toast.success('Seller updated successfully');
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        } else if (action === 'Invite') {
            postData(`sellers/invite`, { email: formData.get('email') }, Token)
                .then((res) => {
                    toast.success(res.message);
                    handleCloseMenu();
                }).catch((error) => {
                    console.error("Error:", error);
                });
        } else {
            formPostData("sellers", formData, Token)
                .then((res) => {
                    getCategoryData();
                    getMerchantData(currentPage);
                    handleClose();
                    handleCloseMenu();
                    toast.success('Seller Added successfully');
                })
                .catch((error) => {
                    console.error("Error:", error);
                });
        }
    }

    const deleteSeller = async () => {
        try {
            const res = await deleteData(`sellers/${id}`, Token);
            getCategoryData();
            getMerchantData(currentPage);
            handleDeleteClose();
            handleCloseMenu();
            toast.success('Seller deleted successfully')
        } catch (error) {
            console.error("Error:", error);
            toast.error("An error occurred. Please try again later.", {});
        }
    }


    const handleViewProduct = () => {
        setViewProduct(!viewProduct)
        handleCloseMenu();
    }

    const handleSwitchChange = (checked, id) => {
        debugger;
        setActiveStates(prev => ({
            ...prev,
            [id]: !checked,
        }));
        const formData = new FormData();
        formData.append('isActive', checked === false ? 0 : 1)

        patchFormData(`sellers/${id}`, formData, Token)
            .then((res) => {
                getMerchantData(currentPage);
                getCategoryData();
                handleClose();
                handleCloseMenu();
                toast.success('Seller updated successfully');
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };

    const handleCategoryChange = (event, newValue) => {
        debugger;
        const selectedIds = newValue.map((item) => item._id);
        setCategories(selectedIds);
    };

    return (

        <>
            <ToastContainer position="top-right" />
            {viewProduct ?
                (
                    <ViewBrand
                        id={id}
                        sellerResponse={sellerResponse}
                        handleViewProduct={handleViewProduct}
                    />
                ) : (
                    <>
                        <Helmet>
                            <title> Sellers</title>
                        </Helmet>

                        <div className='p-0 SellerPage'>
                            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                                <Typography variant="h4" className='title-color SellerTitle' gutterBottom>
                                    Sellers
                                </Typography>
                                <Stack className="SellerSearch" direction="row" alignItems="center" spacing={2}>                                   
                                        <Box
                                            sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "start",
                                                backgroundColor: "none",
                                                borderRadius: "15px",
                                                boxShadow: 1,
                                                marginRight: "20px",
                                                border: "1px solid #010101"
                                            }}
                                        >
                                            <Iconify icon="eva:search-fill" sx={{ marginLeft: "10px" }} />
                                            <InputBase
                                                placeholder="Search"
                                                value={searchText}
                                                onChange={(e) => {
                                                    setSearchText(e.target.value);
                                                    debouncedSearch(e.target.value);
                                                }}
                                                sx={{ marginLeft: "8px" }}
                                            />
                                        </Box>
                                    <div className="SellerButton">
                                        <Button style={{ marginRight: '10px' }} variant="contained" className='Button' onClick={(event) => { handleOpenModal(); setAction('Invite') }} startIcon={<Iconify icon="eva:external-link-fill" />}>
                                            <span className="SellerIcon">  Invite Seller</span>
                                        </Button>
                                        <Button variant="contained" className='Button' onClick={(event) => { handleOpenModal(); setAction('Add') }} startIcon={<Iconify icon="eva:plus-fill" />}>
                                            <span className="SellerIcon"> New Seller </span>
                                        </Button>
                                    </div>
                                </Stack>
                            </Stack>

                            {loading ? (
                                <Loader />
                            ) : (
                                <Card className='card-bg'>
                                    <TableContainer style={{ height: "420px", overflowY: "scroll", width: "100%", background: '#d0e1e9' }}>
                                        <Table stickyHeader style={{ width: "100%" }}>
                                            <TableHead>
                                                <TableRow>
                                                    {/* <TableCell className="table-cl color-dark mx-5" width='11%' align="center">
                                                        Profile Image
                                                    </TableCell> */}
                                                    <TableCell className="table-cl color-dark mx-15" width='20%'>
                                                        Name
                                                    </TableCell>
                                                    <TableCell className="table-cl color-dark mx-15" width='20%'>
                                                        ID
                                                    </TableCell>
                                                    <TableCell className="table-cl color-dark mx-10">
                                                        Phone Number
                                                    </TableCell>
                                                    <TableCell className="table-cl color-dark mx-20">
                                                        Whatsapp Number
                                                    </TableCell>
                                                    {/* <TableCell className="table-cl color-dark">
                                                        Category
                                                    </TableCell> */}
                                                    <TableCell className="table-cl color-dark">
                                                        Status
                                                    </TableCell>
                                                    <TableCell className="table-cl color-dark mx-10">
                                                        Action
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {merchant?.map((item, index) => (
                                                    <TableRow key={index}>
                                                        {/* <TableCell className="table-cl color-dark mx-5" width='5%' align="center">
                                                           
                                                        </TableCell> */}
                                                        <TableCell className="table-cl color-dark mx-15">
                                                            <Stack
                                                                direction="row"
                                                                alignItems="center"
                                                                spacing={2}
                                                            >
                                                                <Stack
                                                                    direction="row"
                                                                    alignItems="center"
                                                                    spacing={2}
                                                                >
                                                                    {item?.profile_picture ? (
                                                                        <Avatar src={item?.profile_picture}></Avatar>
                                                                    ) : (
                                                                        <Avatar>
                                                                            {item.name
                                                                                ? item.name[0]
                                                                                : null}
                                                                        </Avatar>
                                                                    )}
                                                                </Stack>
                                                                <Stack
                                                                    direction="column"
                                                                    alignItems="center"
                                                                >
                                                                    {item?.name ? item?.name : '--'} <br />
                                                                    {
                                                                        item?.pending_brand_setup === true ?
                                                                            <Chip
                                                                                sx={{ fontSize: "8px", fontWeight: "bold", height: "20px", border: "1px solid #010101" }}
                                                                                label={`Brand Setup Pending : ${item.available_brands}`}
                                                                                component='a'
                                                                                variant='outlined'
                                                                            /> : <></>
                                                                    }
                                                                </Stack>
                                                            </Stack>
                                                        </TableCell>
                                                        <TableCell className="table-cl color-dark mx-10">
                                                            {item?.seller_uid ? item?.seller_uid : '--'}
                                                        </TableCell>
                                                        <TableCell className="table-cl color-dark mx-10">
                                                            {item?.phone ? item?.phone : '--'}
                                                        </TableCell>
                                                        <TableCell className="table-cl color-dark mx-20">
                                                            {item?.whatsapp ? item?.whatsapp : '--'}
                                                        </TableCell>
                                                        {/* <TableCell className="table-cl color-dark" style={{
                                                            maxWidth: '200px',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        }}>
                                                            {item?.category_list?.map((item) => item.name).join(', ')}
                                                        </TableCell> */}
                                                        <TableCell>
                                                            <Switch
                                                                checked={item?.isActive === false ? !activeStates : activeStates} // invert for your logic
                                                                onChange={(e) => handleSwitchChange(e.target.checked, item._id)}
                                                            />
                                                        </TableCell>
                                                        <TableCell className="table-cl color-dark mx-10">
                                                            <IconButton
                                                                size="large"
                                                                color="inherit"
                                                                onClick={(event) => {
                                                                    handleOpenMenu(event, item.available_brands);
                                                                    getSellerById(item?._id)
                                                                }}
                                                            >
                                                                <Iconify icon={"eva:more-vertical-fill"} />
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <div className="d-flex flex-wrap justify-content-end m-3">
                                        <FormControl variant="outlined" size="small" style={{ width: "7%" }}>
                                            <Select
                                                labelId="limit-label"
                                                id="limit-select"
                                                value={limit}
                                                onChange={handleLimitChange}
                                            >
                                                <MenuItem value={10}>10</MenuItem>
                                                <MenuItem value={20}>20</MenuItem>
                                                <MenuItem value={30}>30</MenuItem>
                                                <MenuItem value={TotalItems}>All</MenuItem>
                                            </Select>
                                        </FormControl>
                                        <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                                            <Iconify icon={"grommet-icons:previous"} />
                                        </Button>
                                        <Button
                                            onClick={handleNextPage}
                                            disabled={currentPage === totalPages}
                                        >
                                            <Iconify icon={"grommet-icons:next"} />
                                        </Button>
                                    </div>
                                    <Popover
                                        open={Boolean(open)}
                                        anchorEl={open}
                                        onClose={handleCloseMenu}
                                        anchorOrigin={{ vertical: "top", horizontal: "left" }}
                                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                                        PaperProps={{
                                            sx: {
                                                p: 1,
                                                width: 230,
                                                "& .MuiMenuItem-root": {
                                                    px: 1,
                                                    typography: "body2",
                                                    borderRadius: 0.75,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem
                                            onClick={() => {
                                                // setAction("Edit");
                                                // handleOpenModal();
                                                handleViewProduct();
                                            }}
                                        >
                                            <Iconify icon={"raphael:view"} sx={{ mr: 2 }} />
                                            View Brands
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setAction("Edit");
                                                handleOpenModal();
                                            }}
                                        >
                                            <Iconify icon={"eva:edit-fill"} sx={{ mr: 2 }} />
                                            Edit
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setAction("Change Password");
                                                handleOpenModal();
                                            }}
                                        >
                                            <Iconify icon={"eva:lock-fill"} sx={{ mr: 2 }} />
                                            Change Password
                                        </MenuItem>
                                        <MenuItem
                                            onClick={() => {
                                                setOpenDialog(true)
                                                // setOpen(false)
                                            }}
                                        >
                                            <Iconify icon={"eva:checkmark-circle-fill"} sx={{ mr: 2, }} />
                                            Create Another brand
                                        </MenuItem>
                                        <MenuItem
                                            sx={{ color: "error.main" }}
                                            onClick={() => {
                                                handleOpenDeleteModal();
                                            }}
                                        >
                                            <Iconify icon={"eva:trash-2-outline"} sx={{ mr: 2 }} />
                                            Delete
                                        </MenuItem>
                                    </Popover>
                                </Card>
                            )}
                        </div>
                        <Dialog open={openModal} onClose={handleClose} maxWidth="md" fullWidth>
                            <div className="d-flex justify-content-between">
                                <DialogTitle>{action} Seller</DialogTitle>
                                <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px', cursor: "pointer" }} onClick={handleClose} />
                            </div>
                            <DialogContent>
                                {action === 'Edit' || action === 'Add' ? (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} className='mt-3'>
                                            <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                                                <input
                                                    type="file"
                                                    accept="image/*"
                                                    id="fileInput"
                                                    style={{ display: "none" }}
                                                    onChange={handleImageChange}
                                                />
                                                <label htmlFor="fileInput">
                                                    <img
                                                        src={preview}
                                                        alt="Uploaded"
                                                        style={{
                                                            width: "300px",
                                                            height: "230px",
                                                            objectFit: "contain",
                                                            cursor: "pointer",
                                                            borderRadius: "10px",
                                                        }}
                                                    />
                                                    <p className='mb-0' style={{ fontSize: '12px' }}>Upload Profile image</p>
                                                </label>
                                            </div>
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={name}
                                                onChange={(e) => setName(e.target.value)}
                                                label="Name *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={userName}
                                                onChange={(e) => setUserName(e.target.value)}
                                                label="User Name *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                label="Email *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={2} className='mt-3'>
                                            <Autocomplete
                                                options={validDialCodes}
                                                value={phoneCountryCode}
                                                onChange={(event, newValue) => setPhoneCountryCode(newValue)}
                                                renderInput={(params) => <TextField {...params} label="Country Code *" />}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={phone}
                                                onChange={(e) => setPhone(e.target.value)}
                                                label="Mobile Number *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        {action === 'Edit' ? (
                                            <></>
                                        ) : (
                                            <Grid item xs={6} className='mt-3'>
                                                <TextField
                                                    type="password"
                                                    className="w-100"
                                                    id="outlined-basic"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                    label="Password *"
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={2} className='mt-3'>
                                            <Autocomplete
                                                options={validDialCodes}
                                                value={whatsappCountryCode}
                                                onChange={(event, newValue) => setWhatsappCountryCode(newValue)}
                                                renderInput={(params) => <TextField {...params} label="Country Code *" />}
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={4} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={whatsappNo}
                                                onChange={(e) => setWhatsappNo(e.target.value)}
                                                label="whatsapp No *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={aboutUs}
                                                onChange={(e) => setAboutUs(e.target.value)}
                                                label="About Us *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={address}
                                                onChange={(e) => setAddress(e.target.value)}
                                                label="Address *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={city}
                                                onChange={(e) => setCity(e.target.value)}
                                                label="City"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={state}
                                                onChange={(e) => setState(e.target.value)}
                                                label="State"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={country}
                                                onChange={(e) => setCountry(e.target.value)}
                                                label="Country"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={mapLocation}
                                                onChange={(e) => setMapLocation(e.target.value)}
                                                label="Map Location *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={instaLink}
                                                onChange={(e) => setInstaLink(e.target.value)}
                                                label="instagram Link *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={facebookLink}
                                                onChange={(e) => setFaceBookLink(e.target.value)}
                                                label="Facebook Link *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={twitterLink}
                                                onChange={(e) => setTwitterLink(e.target.value)}
                                                label="Twitter Link *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={6} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                // InputProps={{
                                                //     readOnly: action === "View",
                                                // }}
                                                value={websiteLink}
                                                onChange={(e) => setWebsiteLink(e.target.value)}
                                                label="Website Link *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} className='mt-3'>
                                            <Autocomplete
                                                multiple
                                                options={(categoriesArray || []).filter((cat) => cat.subCategoryCount === 0)}
                                                groupBy={(option) => {
                                                    console.log(option.parent, 'option.parent')
                                                    const parent = categoriesArray.find(
                                                        (parentCat) => parentCat._id == option.parent
                                                    );
                                                    return parent?.name || 'Uncategoriezed';
                                                }}
                                                getOptionLabel={(option) => ((option.parent != null) ? "" : "") + `${option.name}`}
                                                value={categoriesArray.filter((item) => categories.includes(item._id))}
                                                onChange={handleCategoryChange}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="Category" variant="outlined" />
                                                )}
                                                renderGroup={(params) => (
                                                    <div key={params.key}>
                                                        <Typography sx={{ mt: 0, mb: 0, fontWeight: 'bold', px: 2, background: '#dbdee2' }}>
                                                            {params.group}
                                                        </Typography>
                                                        {params.children}
                                                    </div>
                                                )}
                                            />

                                        </Grid>
                                        {subCategoriesArray?.length > 0 ? (
                                            <Grid item xs={12} className='mt-3'>
                                                <Autocomplete
                                                    options={subCategoriesArray || []}
                                                    getOptionLabel={(option) => option.name}
                                                    value={subCategoriesArray?.find((item) => item?._id === subCategory?._id) || null}
                                                    onChange={(event, newValue) => handleSubCategoryChange(newValue ? newValue : null, 'parentCategory')}
                                                    renderInput={(params) => (
                                                        <TextField {...params} label="Sub-Category" variant="outlined" />
                                                    )}
                                                />
                                            </Grid>
                                        ) : (
                                            <></>
                                        )}

                                    </Grid>

                                ) : ((action == 'Invite') ? (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                label="Email *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                ) : (
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} className='mt-3'>
                                            <TextField
                                                className="w-100"
                                                id="outlined-basic"
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                                label="Password *"
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                ))}
                                <div className='mt-4 d-flex justify-content-end'>
                                    <Button variant="contained" className='Button' onClick={handleSubmit}>
                                        Submit
                                    </Button>
                                </div>
                            </DialogContent>
                        </Dialog >
                        <Dialog open={openDeleteModal} onClose={handleDeleteClose} maxWidth="sm" fullWidth>
                            <DialogContent className='p-5'>
                                <div>
                                    <div className='d-flex justify-content-center'>
                                        <img src={deleteIcon} width='10%' />
                                    </div>
                                    <h4 className='text-center mt-4'>Confirm deletion?</h4>
                                    <p className='text-center'>Data will be lost forever.</p>
                                    <Button variant="contained" className='Button w-100 mt-3 shadow-none' onClick={(e) => deleteSeller()}>
                                        Yes
                                    </Button>
                                    <Button variant="outlined" className='w-100 mt-3' onClick={(e) => handleDeleteClose()} >
                                        No
                                    </Button>
                                </div>
                            </DialogContent>
                        </Dialog>

                        <Dialog open={openDialog}
                            onClose={() => setOpenDialog(false)} maxWidth="sm" fullWidth>
                            <DialogContent className='p-5'>
                                <div>
                                    {/* <div className='d-flex justify-content-center'>
                                    <img src={deleteIcon} width='10%' />
                                </div> */}
                                    <h4 className='text-center mt-4'>Are You Sure?</h4>
                                    <p className='text-center'>You want to create another brand.</p>

                                    <TextField
                                        label="How many brands"
                                        name="How many brands"
                                        value={brandsCount}
                                        onChange={(e) => setBrandsCount(e.target.value)}
                                        fullWidth
                                        required
                                        error={!!errors.description}
                                        helperText={errors.description}
                                    />

                                    <Button variant="contained" className='Button w-100 mt-3 shadow-none' onClick={(e) => handleApproveAnotherBrand()}>
                                        Yes
                                    </Button>
                                    <Button variant="outlined" className='w-100 mt-3' onClick={() => { setOpenDialog(false); handleCloseMenu() }} >
                                        No
                                    </Button>
                                </div>
                            </DialogContent>
                        </Dialog>
                    </>
                )
            }

        </>
    )
}